/* dogvanture-pdp-rollout.js - v10
   25.10.2026: Review-Hinweis-Section komplett entfernt aus templates/product.json;
   JS kuemmert sich nur noch um Snack-Inspektoren-Section bei Nicht-Snack-PDPs.
   v9: Mix-Pakete als isMix markiert (Probiersnack-Hinweis bei Mixes aus).
   v8: Probiersnack-Hinweis auf Nicht-Snack-PDPs ausblenden.
   v7: Favoriten-Badges KOMPLETT entfernt (20.10.2026).
   Behalten: Rating klickbar, Buy-Hierarchie, Trial-Promo-Note. */
(() => {
  const norm = (s = '') => s.replace(/\s+/g, ' ').trim();
  const info = document.querySelector('.product__info-container');
  if (!info) return;

  const title = norm(document.querySelector('.product__title h1')?.textContent || document.title);
  const typeFromMeta = norm(window.ShopifyAnalytics?.meta?.product?.type || '').toLowerCase();
  const isSnackByTitle = /würfel|kausnack|kauartikel|streifen|stick|lunge|pansen|haut|ohr|entenhals|entenhälse|lachshaut|fisch|pferd|hirsch|reh|ente|perlhuhn|gans|wildschwein|lamm|ziege/i.test(title);
  const isNonSnackType = typeFromMeta && /t-shirt|shirt|hoodie|accessoire|print material|stoffbeutel|beutel|gutschein|digital/.test(typeFromMeta);
  const isMix = /\bmix[\s\-]paket|\bmix\b/i.test(title);
  const isSnackProduct = isSnackByTitle && !isNonSnackType;
  const isSnack = isSnackProduct && !isMix;

  info.classList.add('dv-pdp');
  if (isSnackProduct) info.classList.add('dv-pdp-snack');
  else info.classList.add('dv-pdp-nonsnack');
  if (isMix) info.classList.add('dv-pdp-mix');

  function scrollToReviews() {
    const target = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-review-widget, [data-judgeme-product-reviews]');
    if (!target) return false;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function makeRatingClickable() {
    const rating = info.querySelector('.rating-wrapper');
    if (!rating || rating.dataset.dvReviewJump) return;
    rating.dataset.dvReviewJump = 'true';
    const hasInteractiveChild = !!rating.querySelector('a, button');
    if (rating.tagName !== 'A' && !hasInteractiveChild) {
      rating.setAttribute('role', 'link');
      rating.setAttribute('tabindex', '0');
      rating.setAttribute('aria-label', 'Bewertungen lesen');
      rating.style.cursor = 'pointer';
    }
    rating.addEventListener('click', event => { if (scrollToReviews()) event.preventDefault(); });
    rating.addEventListener('keydown', event => {
      if ((event.key === 'Enter' || event.key === ' ') && scrollToReviews()) event.preventDefault();
    });
  }

  function removeAllFavoriteBadges() {
    info.querySelectorAll('.dv-pdp-favorite').forEach(el => el.remove());
  }

  function setupBuyHierarchy() {
    const addButton = info.querySelector('product-form button[name="add"], .product-form__submit');
    if (addButton) addButton.classList.add('dv-primary-add');
    const payment = info.querySelector('.shopify-payment-button');
    if (payment && !info.querySelector('.dv-express-label')) {
      const label = document.createElement('p');
      label.className = 'dv-express-label';
      label.textContent = 'Oder direkt bezahlen mit';
      payment.insertAdjacentElement('beforebegin', label);
    }
  }

  function isPromoText(text) {
    const lower = text.toLowerCase();
    if (!lower.includes('probiersnack')) return false;
    return lower.includes('erstbestellung')
      || lower.includes('ersten 500')
      || lower.includes('500 g bestellung')
      || lower.includes('500g bestellung')
      || lower.includes('500-g-bestellung')
      || lower.includes('wochenpick');
  }

  function updatePromoCopy() {
    [...info.querySelectorAll('.product__text, p')].forEach(el => {
      const text = norm(el.textContent);
      if (!isPromoText(text)) return;

      if (!isSnack) {
        // Nicht-Snack-Produkte UND Mix-Pakete: Hinweis komplett weg.
        const block = el.closest('.product__block, [id^="Product-"], [id^="ProductBlock-"]') || el;
        block.setAttribute('hidden', '');
        block.style.display = 'none';
        return;
      }

      el.textContent = 'Bei deiner ersten 500-g-Bestellung liegt ein gratis Probiersnack im Paket.';
      el.classList.add('dv-pdp-promo-note');
    });
  }

  function hideSnackInspectorBlock() {
    if (isSnackProduct) return;
    // Bei Shirts/Hoodies/Stoffbeutel: Snack-Inspektoren-Section raus.
    document.querySelectorAll('.shopify-section[id$="__rich_text_BwgyNT"], .shopify-section[id$="rich_text_BwgyNT"]').forEach(section => {
      section.setAttribute('hidden', '');
      section.style.display = 'none';
    });
  }

  function decorate() {
    setupBuyHierarchy();
    makeRatingClickable();
    removeAllFavoriteBadges();
    updatePromoCopy();
    hideSnackInspectorBlock();
  }

  decorate();
  const observer = new MutationObserver(() => requestAnimationFrame(decorate));
  observer.observe(info, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 6000);
})();
